import { render, staticRenderFns } from "./partner-modal.vue?vue&type=template&id=84b2a61a&scoped=true&"
import script from "./partner-modal.vue?vue&type=script&lang=js&"
export * from "./partner-modal.vue?vue&type=script&lang=js&"
import style0 from "./partner-modal.vue?vue&type=style&index=0&id=84b2a61a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b2a61a",
  null
  
)

export default component.exports